import styled from 'styled-components';

export const ContinueWrapper = styled.div`
    margin-top: 24px;
`;
